import { Component, OnInit } from '@angular/core';
import { WorkspaceService, FileInfo } from '../workspace.service';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  standalone: false,  // this is now required when using NgModule
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.css']
})
export class FilesComponent implements OnInit {

  constructor(public workspaceService:WorkspaceService) {

  }

  ngOnInit(): void {
  }

}
